import {
  HttpContext,
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ERRORS } from '../../error/error-messages.const';
import { AlertService } from '../../../shared/services/alert.service';

const SILENT_ERROR_CODES = new HttpContextToken<HttpStatusCode[]>(() => []);
const SKIP_ERROR_INTERCEPTING = new HttpContextToken<boolean>(() => false);

export const errorContext = (silentStatuses: HttpStatusCode[]) =>
  new HttpContext().set(SILENT_ERROR_CODES, silentStatuses);

export const skipErrorInterceptorContext = () =>
  new HttpContext().set(SKIP_ERROR_INTERCEPTING, true);

const availableStatusCode = Object.keys(ERRORS).map((status) => Number(status));

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const alertService = inject(AlertService);
  return next(req).pipe(
    catchError((error) => {
      if (isIssuerRequest(req.url)) {
        return throwError(() => error);
      }

      if (error instanceof HttpErrorResponse) {
        if (req.context.get(SKIP_ERROR_INTERCEPTING)) {
          return throwError(() => error);
        }

        const silentStatuses = req.context.get(SILENT_ERROR_CODES);
        const statusCode = error.status;

        if (
          statusCode == HttpStatusCode.BadRequest &&
          isIntercepted(HttpStatusCode.BadRequest, silentStatuses)
        ) {
          alertService.error(error.error.message);

          return throwError(() => error);
        }
        if (
          statusCode === HttpStatusCode.UnprocessableEntity &&
          isIntercepted(HttpStatusCode.UnprocessableEntity, silentStatuses)
        ) {
          alertService.error(error.error);
        }
        if (
          isIntercepted(statusCode, silentStatuses) &&
          availableStatusCode.includes(statusCode)
        ) {
          // Redirect to the corresponding error page
          router.navigate(['/access-denied', statusCode]);
        }

        console.error(error);
      }

      return throwError(() => error);
    }),
  );
};

function isIntercepted(
  statusCode: HttpStatusCode,
  silentStatuses: number[],
): boolean {
  return !silentStatuses.includes(statusCode);
}

function isIssuerRequest(url: string) {
  return url.includes(environment.issuer);
}
